import { FC, useEffect } from 'react';
import { Router as RRouter } from 'react-router-dom';

import { getAccessToken } from 'utils/auth';
import { updateUserData } from 'utils/userDataSync';
import API from 'core/Api';
import { useWorkModeContext } from 'store/work-mode';
import { usePermissionsContext } from 'store/permissions';
import { useLanguageContext } from 'store/language';
import { useActiveClientContext } from 'store/active-client';
import Routes from './Routes';
import history from './history';

const Router: FC = () => {
  const { setPermissions } = usePermissionsContext();
  const { setWorkMode, setWorkModeName, setAltWorkModeName } = useWorkModeContext();
  const { setLanguage } = useLanguageContext();

  const { client } = useActiveClientContext();

  const clientId = client!.id;
  useEffect(() => {
    // Control check if user tokens
    // are still valid on starting app
    const isLoggedIn = getAccessToken();
    if (isLoggedIn) {
      updateUserData({
        setWorkMode,
        setWorkModeName,
        setAltWorkModeName,
        setLanguage,
      })
        .then(() => API.get('permissions'))
        .then(res => {
          setPermissions(res.data);
        })
        .catch(err => console.error(err));
    }
  }, [clientId]);

  return (
    <RRouter history={history}>
      <Routes />
    </RRouter>
  );
};

export default Router;
